import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    dashboardDetailsList: [],
    userCountDetailsList: [],
    activeSessionDetailsList: [],
    dataTransferDetailsList: [],
    activeUserDetailsList: [],
    activeOnlineUserDetailsList: [],
    activeUserAccountDetailsList: [],
    totalUserDetailsList: [],
    paymentDetailsList: [],
    ticketDetailsList: [],
    leadDetailsList: [],
    revenueDetailsList: [],
    franchiseRevenueDetailsList: [],
    paymentCollectionDayWiseDetailsList: [],
    paymentCollectionAccountWiseDetailsList: [],
    nasWiseActiveSessionDetailsList: [],
    newRegistrationDetailsList: [],
    renewedUsersDetailsList: [],
    totalExpiredUsersDetailsList: [],
    loginTypeDetailsList: [],
    payAsYouGoUserDetailsList: [],
    tasksCountDetailsList: [],
    helpDeskCountDetailsList: [],
    renewalDetailsList: [],
    sessionCountList: [],
    overviewList: [],
    getOverviewList: [],
    createSubzoneDetail: []
}

const mutations = {
    SET_DASHBOARD_DETAILS_LIST(state, data) {
        var tData = {};
        var parseData = data.message;
        if (Object.keys(state.dashboardDetailsList).length == 0) {
            tData['DashBoardDetailsList'] = parseData;
            state.dashboardDetailsList = tData;
        } else {
            Vue.set(state.dashboardDetailsList, parseData);
        };
    },
    SET_USER_COUNT_LIST(state, data) {
        var tData = {};
        var parseData = data.res;
        if (Object.keys(state.userCountDetailsList).length == 0) {
            tData['UserCountDetailsList'] = parseData;
            state.userCountDetailsList = tData;
        } else {
            Vue.set(state.userCountDetailsList, parseData);
        };
    },
    SET_ACTIVE_SESSION_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.activeSessionDetailsList).length == 0) {
            tData['ActiveSessionDetailsList'] = parseData;
            state.activeSessionDetailsList = tData;
        } else {
            Vue.set(state.activeSessionDetailsList, parseData);
        };
    },
    SET_DATA_TRANSFER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.dataTransferDetailsList).length == 0) {
            tData['DataTransferDetailsList'] = parseData;
            state.dataTransferDetailsList = tData;
        } else {
            Vue.set(state.dataTransferDetailsList, parseData);
        };
    },
    SET_ACTIVE_USER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.activeUserDetailsList).length == 0) {
            tData['ActiveUserDetailsList'] = parseData;
            state.activeUserDetailsList = tData;
        } else {
            Vue.set(state.activeUserDetailsList, parseData);
        };
    },
    SET_ACTIVE_ONLINE_USER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.activeOnlineUserDetailsList).length == 0) {
            tData['ActiveOnlineUserDetailsList'] = parseData;
            state.activeOnlineUserDetailsList = tData;
        } else {
            Vue.set(state.activeOnlineUserDetailsList, parseData);
        };
    },

    SET_ACTIVE_USER_ACCOUNT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.activeUserAccountDetailsList).length == 0) {
            tData['ActiveUserAccountDetailsList'] = parseData;
            state.activeUserAccountDetailsList = tData;
        } else {
            Vue.set(state.activeUserAccountDetailsList, parseData);
        };
    },
    SET_TOTAL_USER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.totalUserDetailsList).length == 0) {
            tData['TotalUserDetailsList'] = parseData;
            state.totalUserDetailsList = tData;
        } else {
            Vue.set(state.totalUserDetailsList, parseData);
        };
    },
    SET_PAYMENT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.paymentDetailsList).length == 0) {
            tData['PaymentDetailsList'] = parseData;
            state.paymentDetailsList = tData;
        } else {
            Vue.set(state.paymentDetailsList, parseData);
        };
    },
    SET_TICKET_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.ticketDetailsList).length == 0) {
            tData['TicketDetailsList'] = parseData;
            state.ticketDetailsList = tData;
        } else {
            Vue.set(state.ticketDetailsList, parseData);
        };
    },
    SET_LEAD_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.leadDetailsList).length == 0) {
            tData['LeadDetailsList'] = parseData;
            state.leadDetailsList = tData;
        } else {
            Vue.set(state.leadDetailsList, parseData);
        };
    },
    SET_REVENUE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.revenueDetailsList).length == 0) {
            tData['RevenueDetailsList'] = parseData;
            state.revenueDetailsList = tData;
        } else {
            Vue.set(state.revenueDetailsList, parseData);
        };
    },
    SET_FRANCHISE_REVENUE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.franchiseRevenueDetailsList).length == 0) {
            tData['FranchiseRevenueDetailsList'] = parseData;
            state.franchiseRevenueDetailsList = tData;
        } else {
            Vue.set(state.franchiseRevenueDetailsList, parseData);
        };
    },
    SET_PAYMENT_COLLECTION_DAYWISE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.paymentCollectionDayWiseDetailsList).length == 0) {
            tData['PaymentCollectionDayWiseDetailsList'] = parseData;
            state.paymentCollectionDayWiseDetailsList = tData;
        } else {
            Vue.set(state.paymentCollectionDayWiseDetailsList, parseData);
        };
    },
    SET_PAYMENT_COLLECTION_ACCOUNTWISE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.paymentCollectionAccountWiseDetailsList).length == 0) {
            tData['PaymentCollectionAccountWiseDetailsList'] = parseData;
            state.paymentCollectionAccountWiseDetailsList = tData;
        } else {
            Vue.set(state.paymentCollectionAccountWiseDetailsList, parseData);
        };
    },
    SET_PAYMENT_COLLECTION_ACCOUNTWISE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.paymentCollectionAccountWiseDetailsList).length == 0) {
            tData['PaymentCollectionAccountWiseDetailsList'] = parseData;
            state.paymentCollectionAccountWiseDetailsList = tData;
        } else {
            Vue.set(state.paymentCollectionAccountWiseDetailsList, parseData);
        };
    },
    SET_NAS_WISE_ACTIVE_SESSION_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.nasWiseActiveSessionDetailsList).length == 0) {
            tData['NasWiseActiveSessionDetailsList'] = parseData;
            state.nasWiseActiveSessionDetailsList = tData;
        } else {
            Vue.set(state.nasWiseActiveSessionDetailsList, parseData);
        };
    },
    SET_NEW_REGISTRATION_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.newRegistrationDetailsList).length == 0) {
            tData['NewRegistrationDetailsList'] = parseData;
            state.newRegistrationDetailsList = tData;
        } else {
            Vue.set(state.newRegistrationDetailsList, parseData);
        };
    },
    SET_RENEWED_USER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.renewedUsersDetailsList).length == 0) {
            tData['RenewedUsersDetailsList'] = parseData;
            state.renewedUsersDetailsList = tData;
        } else {
            Vue.set(state.renewedUsersDetailsList, parseData);
        };
    },
    SET_TOTAL_EXPIRED_USER_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.totalExpiredUsersDetailsList).length == 0) {
            tData['TotalExpiredUsersDetailsList'] = parseData;
            state.totalExpiredUsersDetailsList = tData;
        } else {
            Vue.set(state.totalExpiredUsersDetailsList, parseData);
        };
    },
    SET_LOGIN_TYPE_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.loginTypeDetailsList).length == 0) {
            tData['LoginTypeDetailsList'] = parseData;
            state.loginTypeDetailsList = tData;
        } else {
            Vue.set(state.loginTypeDetailsList, parseData);
        };
    },
    SET_PAYAS_USER_COUNT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.payAsYouGoUserDetailsList).length == 0) {
            tData['PayAsYouGoUserDetailsList'] = parseData;
            state.payAsYouGoUserDetailsList = tData;
        } else {
            Vue.set(state.payAsYouGoUserDetailsList, parseData);
        };
    },
    SET_TASK_COUNT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.tasksCountDetailsList).length == 0) {
            tData['TaskCountDetailsList'] = parseData;
            state.tasksCountDetailsList = tData;
        } else {
            Vue.set(state.tasksCountDetailsList, parseData);
        };
    },
    SET_HELPDESK_COUNT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.helpDeskCountDetailsList).length == 0) {
            tData['HelpDeskCountDetailsList'] = parseData;
            state.helpDeskCountDetailsList = tData;
        } else {
            Vue.set(state.helpDeskCountDetailsList, parseData);
        };
    },
    SET_RENEWAL_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.renewalDetailsList).length == 0) {
            tData['RenewalDetailsList'] = parseData;
            state.renewalDetailsList = tData;
        } else {
            Vue.set(state.renewalDetailsList, parseData);
        };
    },
    SET_SESSION_COUNT_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.sessionCountList).length == 0) {
            tData['SessionCountDetailsList'] = parseData;
            state.sessionCountList = tData;
        } else {
            Vue.set(state.sessionCountList, parseData);
        };
    },
    SET_OVERVIEW_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.overviewList).length == 0) {
            tData['OverviewDetailsList'] = parseData;
            state.overviewList = tData;
        } else {
            Vue.set(state.overviewList, parseData);
        };
    },
    SET_ALL_OVERVIEW_LIST(state, data) {
        var tData = {};
        var parseData = data;
        if (Object.keys(state.getOverviewList).length == 0) {
            tData['GetOverviewDetailsList'] = parseData;
            state.getOverviewList = tData;
        } else {
            Vue.set(state.getOverviewList, parseData);
        };
    },
    SET_CREATE_SUBZONE_DETAIL(state, data) {
        state.createSubzoneDetail = data;
    },
    CLEAR_DASHBOARD_STATE(state) {
        state.dashboardDetailsList = [];
        state.userCountDetailsList = [];
        state.activeSessionDetailsList = [];
        state.dataTransferDetailsList = [];
        state.activeUserDetailsList = [];
        state.activeOnlineUserDetailsList =[];
        state.activeUserAccountDetailsList = [];
        state.totalUserDetailsList = [];
        state.paymentDetailsList = [];
        state.ticketDetailsList = [];
        state.leadDetailsList = [];
        state.revenueDetailsList = [];
        state.franchiseRevenueDetailsList = [];
        state.paymentCollectionDayWiseDetailsList = [];
        state.paymentCollectionAccountWiseDetailsList = [];
        state.nasWiseActiveSessionDetailsList = [];
        state.newRegistrationDetailsList = [];
        state.renewedUsersDetailsList = [];
        state.totalExpiredUsersDetailsList = [];
        state.loginTypeDetailsList = [];
        state.payAsYouGoUserDetailsList = [];
        state.tasksCountDetailsList = [];
        state.helpDeskCountDetailsList = [];
        state.renewalDetailsList = [];
        state.sessionCountList = [];
        state.overviewList = [];
        state.getOverviewList = [];
        state.createSubzoneDetail = [];
    }
}

const actions = {
    clearDashboardsState({
        commit,
        dispatch
    }) {
        commit('CLEAR_DASHBOARD_STATE')
    },
    fetchDashboardDetail({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/dashboard/index/' + true + '/' + postData.account + "/" + true)
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        if (postData.checkTrue != "checkTrue") {
                            state.dashboardDetailsList = new Array();
                            commit('SET_DASHBOARD_DETAILS_LIST', res.data)
                        } else {
                            resolve(res.data);
                        }
                    }
                })
                .catch(error => console.log(error))
        });
    },
    fetchUserCountDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count/' + postData.account + '/' + postData.detailType)
            .then(res => {
                Nprogress.done()
                state.userCountDetailsList = new Array();
                commit('SET_USER_COUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchActiveSessionDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/active_sessions_count/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.activeSessionDetailsList = new Array();
                commit('SET_ACTIVE_SESSION_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchDataTransferDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/traffic_data/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.dataTransferDetailsList = new Array();
                commit('SET_DATA_TRANSFER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchActiveUserDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/active_users_count_all/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.activeUserDetailsList = new Array();
                commit('SET_ACTIVE_USER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },

    fetchActiveOnlineUserDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/users_count_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.activeOnlineUserDetailsList = new Array();
                commit('SET_ACTIVE_ONLINE_USER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchActiveUserAccountDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/active_users_account_wise_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.activeUserAccountDetailsList = new Array();
                commit('SET_ACTIVE_USER_ACCOUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchTotalUserDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/total_users_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.totalUserDetailsList = new Array();
                commit('SET_TOTAL_USER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchPaymentDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/payment_type/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.paymentDetailsList = new Array();
                commit('SET_PAYMENT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchTicketDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/tickets_status/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.ticketDetailsList = new Array();
                commit('SET_TICKET_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchLeadDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/lead_users_status_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.leadDetailsList = new Array();
                commit('SET_LEAD_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchRevenueDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/revenue_status_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.revenueDetailsList = new Array();
                commit('SET_REVENUE_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchfranchiseRevenueDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/FranchiseManagement/get_revenue_details/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.franchiseRevenueDetailsList = new Array();
                commit('SET_FRANCHISE_REVENUE_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchPaymentCollectionDayWiseDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/day_wise_payment_amount_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.paymentCollectionDayWiseDetailsList = new Array();
                commit('SET_PAYMENT_COLLECTION_DAYWISE_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchPaymentCollectionAccountWiseDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/account_wise_payment_amount_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.paymentCollectionAccountWiseDetailsList = new Array();
                commit('SET_PAYMENT_COLLECTION_ACCOUNTWISE_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchNasWiseActiveSessionDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/nas_wise_active_sessions_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.nasWiseActiveSessionDetailsList = new Array();
                commit('SET_NAS_WISE_ACTIVE_SESSION_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchNewRegistrationDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/new_registration/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.newRegistrationDetailsList = new Array();
                commit('SET_NEW_REGISTRATION_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchRenewedUsersDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/renewed_users/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.renewedUsersDetailsList = new Array();
                commit('SET_RENEWED_USER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchTotalExpiredUsersDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('dashboard/total_expired_users_graph/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.totalExpiredUsersDetailsList = new Array();
                commit('SET_TOTAL_EXPIRED_USER_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchLoginTypeDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('analytics/login_type/' + postData.duration + '/dash' + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.loginTypeDetailsList = new Array();
                commit('SET_LOGIN_TYPE_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchPayAsYouGoUserDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count' + '/' + postData.account + '/payAsYouGoUsersCount')
            .then(res => {
                Nprogress.done()
                state.payAsYouGoUserDetailsList = new Array();
                commit('SET_PAYAS_USER_COUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchtaskCountDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count' + '/' + postData.account + '/tasksCount')
            .then(res => {
                Nprogress.done()
                state.tasksCountDetailsList = new Array();
                commit('SET_TASK_COUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchHelpDeskCountDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count' + '/' + postData.account + '/helpDeskCount')
            .then(res => {
                Nprogress.done()
                state.helpDeskCountDetailsList = new Array();
                commit('SET_HELPDESK_COUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchRenewalDetailsList({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count' + '/' + postData.account + '/renewalDetails')
            .then(res => {
                Nprogress.done()
                state.renewalDetailsList = new Array();
                commit('SET_RENEWAL_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchSessionCountDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/analytics/dashboard_analytics_data/' + postData.duration + '/dash/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.sessionCountList = new Array();
                commit('SET_SESSION_COUNT_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchOverviewDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/set_users_count/' + postData.account + '/overviewDetails')
            .then(res => {
                Nprogress.done()
                state.overviewList = new Array();
                commit('SET_OVERVIEW_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchGetOverviewDetails({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/get_overview_details/' + postData.duration + '/' + postData.account)
            .then(res => {
                Nprogress.done()
                state.getOverviewList = new Array();
                commit('SET_ALL_OVERVIEW_LIST', res.data)

            })
            .catch(error => console.log(error))
    },
    fetchCreateSubzoneDetail({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        axios.get('/dashboard/create_subaccount/' + postData.accountId + '/' + true)
            .then(res => {
                Nprogress.done()
                commit('SET_CREATE_SUBZONE_DETAIL', res.data.message);
            })
            .catch(error => console.log(error))
    },
    createSubAccountSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/create_sub_account_data', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status == "pending") {
                        reject("pending");
                    } else if (response.data.status != "success") {
                        reject(response.data.message);
                    } else {
                        if (response.data.message != null && response.data.message != '') {
                            var url = "/dashboard/create_subaccount" + '/' + response.data.message;
                            router.push(url);
                            resolve(response.data);
                        } else {
                            var msg = "Sub-account <strong>" + postData.subAccountName + "</strong> has been created.";
                            resolve(msg);
                        }

                    }

                })
                .catch(error => console.log(error));
        });
    },
    createcopySettingsSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/copy_account_settings', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data.message);
                    } else {
                        resolve(response.data);
                    }

                })
                .catch(error => console.log(error));
        });
    },
    prefixSettingsSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/prefix_settings', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data.message);
                    } else {
                        resolve(response.data);
                    }

                })
                .catch(error => console.log(error));
        });
    },
    gotoBackStepSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/go_to_back_step', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != "success") {
                    reject(response.data.message);
                } else {
                    resolve(response.data);
                }

            })
                .catch(error => console.log(error));
        });
    },

    routerSettingSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/add_router_subaccount', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != "success") {
                    reject(response.data.message);
                } else {
                    resolve(response.data);
                }

            })
                .catch(error => console.log(error));
        });
    },
    tagPaymentGatewaySubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/tag_payment_franchise', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data.message);
                    } else {
                        resolve(response.data);
                    }

                })
                .catch(error => console.log(error));
        });
    },
    addAdminCreateFormSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/network_admins/add_admin', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != "success") {
                        reject(response.data.message);
                    } else {
                        router.push("/dashboard");
                    }

                })
                .catch(error => console.log(error));
        });
    },
    skipcreateAdminAccountSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/dashboard/skip_create_admin', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != "success") {
                    reject(response.data.message);
                } else {
                    router.push("/dashboard");
                }

            })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    dashboardDetailsListGetters: state => {
        return state.dashboardDetailsList;
    },
    userCountDetailsListGetters: state => {
        return state.userCountDetailsList;
    },
    activeSessionDetailsListGetters: state => {
        return state.activeSessionDetailsList;
    },
    dataTransferDetailsListGetters: state => {
        return state.dataTransferDetailsList;
    },
    activeUserDetailsListGetters: state => {
        return state.activeUserDetailsList;
    },
    activeOnlineUserDetailsListGetters: state => {
        return state.activeOnlineUserDetailsList;
    },
    activeUserAccountDetailsListGetters: state => {
        return state.activeUserAccountDetailsList;
    },
    totalUserDetailsListGetters: state => {
        return state.totalUserDetailsList;
    },
    paymentDetailsListGetters: state => {
        return state.paymentDetailsList;
    },
    ticketDetailsListGetters: state => {
        return state.ticketDetailsList;
    },
    leadDetailsListGetters: state => {
        return state.leadDetailsList;
    },
    revenueDetailsListGetters: state => {
        return state.revenueDetailsList;
    },
    franchiseRevenueDetailsListGetters: state => {
        return state.franchiseRevenueDetailsList;
    },
    paymentCollectionDayWiseGetters: state => {
        return state.paymentCollectionDayWiseDetailsList;
    },
    paymentCollectionAccountWiseGetters: state => {
        return state.paymentCollectionAccountWiseDetailsList;
    },
    nasWiseActiveSessionGetters: state => {
        return state.nasWiseActiveSessionDetailsList;
    },
    newRegistrationGetters: state => {
        return state.newRegistrationDetailsList;
    },
    renewedUsersGetters: state => {
        return state.renewedUsersDetailsList;
    },
    TotalExpiredUsersGetters: state => {
        return state.totalExpiredUsersDetailsList;
    },
    loginTypeGetters: state => {
        return state.loginTypeDetailsList;
    },
    payAsYouGoUserCountGetters: state => {
        return state.payAsYouGoUserDetailsList;
    },
    tasksCountGetters: state => {
        return state.tasksCountDetailsList;
    },
    helpDeskCountGetters: state => {
        return state.helpDeskCountDetailsList;
    },
    renewalDetailsGetters: state => {
        return state.renewalDetailsList;
    },
    sessionCountListGetters: state => {
        return state.sessionCountList;
    },
    overviewDetailsListGetters: state => {
        return state.overviewList;
    },
    getOverviewDetailsListGetters: state => {
        return state.getOverviewList;
    },
    createSubzoneDetailGetters: state => {
        return state.createSubzoneDetail;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}